import { Button, FormControl, IconButton, Input, InputAdornment, InputLabel, TextField } from "@mui/material";
import { EmptyState } from "../MachineOverviewPage/EmptyStat";
import { Add, AddIcCallOutlined, Search } from "@mui/icons-material";
import { connect } from "react-redux";
import { ReactComponent as BFilterSvg } from "../../assets/BlueFilter.svg";
import { ReactComponent as AddSvg } from "../../assets/AddIcon.svg";
import KundenTable from "./KundenTable";
import { useNavigate } from "react-router";
import { useState } from "react";
import { withCurrentAccountPrefix } from "../../utils/accountMode";

export default connect(({ i18n }) => ({ i18n }))((props) => {


  const navigate = useNavigate();
  const handleClick = () => {
    navigate(withCurrentAccountPrefix("/new-kunden"))
  }

  return (

    <>
      {/* <div className="kunden_dashboard_parent bxShadow">
        <div className="_header">
          <div className="_title">
            Kundenliste (0) <Button variant="contained"  onClick={handleClick}> <Add /> &nbsp; NEU </Button>
          </div>
          <div className="search_bar area_disabled">
            <FormControl sx={{ m: 1, width: "100%" }} variant="standard">
              <Input
                fullWidth
                placeholder="Kunden durchsuchen"
                id="standard-adornment-password"
                type="text"
                disabled
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </div>
          <div className="filters area_disabled">
            <BFilterSvg />
            <span style={{ marginLeft: "6px" }}>Filters</span>
          </div>
        </div>

        <EmptyState
          heading={""}
          title={"Sie haben noch keine Kunden angelegt"}
          description={
            "Legen Sie jetzt einen neuen Datensatz an und ordnen Sie dem Kunden User, Standorte und Maschinen zu."
          }
          icon={
            <AddSvg />
          }
          hasButton
          button={
            <div style={{ marginTop: "20px" }}>

              <Button
                onClick={handleClick}
                startIcon={<Add />}
                variant="contained"
                color="primary"
              >
                {props.i18n.add_new_kunden}
              </Button>
            </div>
          }
        />
      </div >
      <br/>
        <br/> */}

      <KundenTable />
          <br/>
          <br/>

    </>

  );
})
